import React from 'react';
import { Typography } from '@waglabs/typography';
export const ModalHeadingText = (props) => (React.createElement(Typography, Object.assign({ color: "#474747", fontSize: ['mobile-h1', 'tablet-h1'], fontWeight: "700", m: 0, maxWidth: ['232px', '216px'], variant: "h1" }, props)));
